import React from "react";
import "./ProfileSearch.scss";

const ProfileSearch = ({
  getDataSearch,
  setSearch,
  search,
  user,
  setProfiles,
  setLoading,
  dataReset,
  type,
  searchType,
}) => {
  let reset = document.getElementById("search-cases");
  return (
    <div>
      <div>
        <div role="search" className="profiles_search">
          <input
            id="search-cases"
            className="searchInput"
            name="search"
            type="text"
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          ></input>
          <button
            className="caseFilterSubmitProfiles"
            id="searchField"
            onClick={() =>
              getDataSearch(search, searchType, user, setProfiles, setLoading)
            }
          >
            Search
          </button>
          <button
            className="reset-button"
            onClick={() => {
              dataReset(type, user, setProfiles, setLoading);
              reset.value = "";
              setSearch("");
            }}
          >
            Reset
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileSearch;
